interface LoadingScreenProps {
  label?: string;
  className?: string;
}

const LoadingScreen = ({ label = 'Carregando...', className = '' }: LoadingScreenProps) => (
  <div className={`flex min-h-64 items-center justify-center ${className}`} role="status" aria-live="polite">
    <div className="flex items-center gap-3 text-dark-300">
      <span className="h-8 w-8 animate-spin rounded-full border-2 border-dark-600 border-b-purple-500" aria-hidden="true" />
      <span>{label}</span>
    </div>
  </div>
);

export default LoadingScreen;
